import { useCallback } from 'react'
import { useSessionStorage } from 'usehooks-ts'

export {
  CSW_INTERACTED_KEY,
  SEARCH_INTERACTED_KEY,
} from '../eventTracking/experimentsInteractionSessionStorage'

export const useSetSessionStorageValuesForOptimizelyTracking = (
  key: string,
  initialValue = false,
): (() => void) => {
  const [interacted, setInteracted] = useSessionStorage(key, initialValue, {
    initializeWithValue: false,
  })

  return useCallback(() => {
    if (!interacted) {
      setInteracted(true)
    }
  }, [interacted, setInteracted])
}
